import { Component, OnInit, EventEmitter, Output } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as _ from "lodash";
import { ItemLibrary } from "app/infrastructure/model/classes/itemLibrary.class";
import { ReportConfigurationService } from "app/infrastructure/services/reportConfiguration.service";
import { ReportConfiguration } from "app/infrastructure/model/interfaces/reportConfiguration.interface";

interface FilterItem {
  value: string;
  selected: boolean;
}

interface Filter {
  country: FilterItem[];
  type: FilterItem[];
  insurance: FilterItem[];
}

@Component({
  selector: "app-desktop",
  templateUrl: "./subscribe.report.configuration.component.html",
  styleUrls: ['./subscribe.report.configuration.component.css']
})
export class SubscribeReportConfigurationComponent implements OnInit {
  organizationCode: string;
  subscriptionCode: string;
  channelCode: string;
  productCode: string;
  isLoading: Boolean = true;
  selectedReportConfiguration: ReportConfiguration = null;
  selectedReportConfigurationId: string = null;
  organizations: ReportConfiguration[] = [];
  organizationsFiltered: any = {};
  search = "";
  objectKeys = Object.keys;

  @Output() onSelect: EventEmitter<ItemLibrary> = new EventEmitter<ItemLibrary>();

  constructor(
    private modalService: NgbModal,
    private aRoute: ActivatedRoute,
    private router: Router,
    public reportConfigurationSrv: ReportConfigurationService
  ) {}

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.organizationCode = params["codorganizacion"];
      this.subscriptionCode = params["codsistema"];
      this.channelCode = params["codnegocio"];
      this.productCode = params["codproducto"];

      this.reportConfigurationSrv
        .getAllWithContext(this.organizationCode,this.subscriptionCode,  this.channelCode, this.productCode)
        .subscribe(res => {
          this.isLoading = false;
          this.organizations = res;
          this.grouping(res);
        });
    });
  }

  grouping(reportConfigurationList: ReportConfiguration[]): void {
    this.organizationsFiltered = _.groupBy(reportConfigurationList, (reportConfiguration) => {
        return reportConfiguration.category.codOrganization;
    });
  }

  clickEdit() {
    this.router.navigate([".", this.selectedReportConfigurationId], {
      relativeTo: this.aRoute,
    });
  }

  clickImport() {
    this.router.navigate([".", this.selectedReportConfigurationId, "import"], {
      relativeTo: this.aRoute,
    });
  }

  selectLibrary(reportConfiguration: ReportConfiguration) {
    this.selectedReportConfigurationId = reportConfiguration.id;
    this.selectedReportConfiguration = reportConfiguration;
  }


  addIfNotExists(collection: FilterItem[], value: string) {
    const exists = collection.find((item) => item.value === value);
    if (!exists) {
      collection.push({ value, selected: true });
    }
  }

  reportConfigurationSelected(reportConfiguration: ReportConfiguration) {
    this.selectedReportConfiguration = reportConfiguration;
  }

  applySearch(value: string) {
    if(value === "")
      this.grouping(this.organizations);
    else
    {
      let filtered = this.organizations.filter(
        org =>
          org.name.toUpperCase().indexOf(value.toUpperCase()) !== -1
      );
      this.grouping(filtered);
    }
  }

  // getObjectKeys(){
  //   console.log (this.organizationsFiltered);
  //   return Object.keys(this.organizationsFiltered)
  // }

  volver() {
    this.router.navigate(["../"], { relativeTo: this.aRoute });
  }

  subscribe(id: string) {
    const reportConfigurationContext = {
      "organizationCode": this.organizationCode,
      "subscriptionCode": this.subscriptionCode,
      "channelCode": this.channelCode,
      "productCode": this.productCode,
      "entityId": [`${id}`]
    };

    this.reportConfigurationSrv.reportConfigurationSubscription(reportConfigurationContext).subscribe(resp => {
      if(resp) this.volver();
    })
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/reportConfiguration/subscribe/subscribe.report.configuration.component.ts